module.exports = __webpack_public_path__ + "assets/img/nav-item-5-d58438ba.png";